import { z } from 'zod';
import { Moment, isMoment } from 'moment';

export const momentZodType = z.custom<Moment>(((data: Moment) => isMoment(data)) as any);
